module.exports = __webpack_public_path__ + "img/2_banner.376e1fef.png";